<script>
import playground from "../../../mixins/playground/playground";
import Response from "./ResultadoApi.vue";
import numeroProcesso from "../../../mixins/playground/numeroProcesso";

export default {
  name: "ProcessoMovimentacoes",
  mixins:[playground, numeroProcesso],
  components: { Response },
  computed: {
    colunas() {
      return [
        { key: "conteudo", label: "Conteúdo", isVisible: true },
        { key: "tipo", label: "Tipo", isVisible: true },
        { key: "fonteSigla", label: "Fonte", isVisible: true },
        { key: "fonteNome", label: "Nome da fonte", isVisible: false },
        { key: "grauFormatado", label: "Grau", isVisible: true },
        { key: "tipoFonte", label: "Tipo da Fonte", isVisible: false },
        { key: "data", label: "Data", isVisible: true },
        { key: "classificacao", label: "Nome (IA)", isVisible: false },
        { key: "hierarquia", label: "Hierarquia (IA)", isVisible: false },
        { key: "descricao", label: "Descrição (IA)", isVisible: false },
        { key: "tipoPublicacao", label: "Tipo da publicação", isVisible: false },
        { key: "textoCategoria", label: "Texto da Categoria", isVisible: false },
      ];
    },
  },
}
</script>

<template>
  <div>
    <form id="form-playground-movimentacoes-processo" class="form-playground" @submit.prevent="consultar">
      <div class="space-y-2">
        <label for="numero_cnj" class="font-medium text-sm">Número CNJ</label>
        <input
          id="movimentacoes_numero_cnj"
          name="numero_cnj"
          v-model="numero"
          class="input is-large px-2 rounded-md block"
          type="text"
          v-mask="'#######-##.####.#.##.####'"
          placeholder="0000000-00.0000.0.00.0000"
          autofocus="autofocus"
        />
      </div>
    </form>

    <div class="custo">
      <slot name="custo"></slot>
    </div>

    <Btn
      class="btn playground-button consultar-button"
      type="button"
      :loading="$wait.is(`fetching_${this.identificador}`)"
      :disabled="$wait.is(`fetching_${this.identificador}`) || inputInvalido"
      @click="consultar"
    >
      <p class="m-0 font-semibold">Consultar</p>
    </Btn>

    <Response
      v-if="response"
      :responseApi="response"
      :identificador="identificador"
      :key="identificador"
      :logIds="logIds"
      :lista-formatada="itens"
      :colunas="colunas"
      @carregar-mais-processo-movimentacoes="carregarMais"
    >
    </Response>
  </div>
</template>

<style scoped lang="stylus">
.form-playground
  display flex
  flex-direction column
  gap 15px

.form-playground .input
  width 18.5rem

  @media (max-width: 768px)
    width 100%

.custo
  width 18.5rem

  @media (max-width: 768px)
    width 100%

.playground-button
  background-color #2393ae
  color #fff
  font-size 12px
  border-radius 5px
  font-weight 500

.playground-button:hover
  opacity 0.8

.consultar-button
  padding 20px 40px
</style>
